// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText__8U7D0","small":"RichText_small__PAPoG","white":"RichText_white__52tCv"};